import { useState, useEffect, useRef } from "react";
import Button from "../../../../components/forms/Button";
import OtpInput from 'react-otp-input';

import "./index.scss";
import { Input } from "antd";
import { t } from '../../../../utils/i18n';

const FillCode = props => {
    const { code, setCode } = props;
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [timeLeft, setTimeLeft] = useState(30);
    const [canResend, setCanResend] = useState(false);

    useEffect(() => {
        if (timeLeft > 0) {
            const timer = setTimeout(() => {
                setTimeLeft(timeLeft - 1);
            }, 1000);
            return () => clearTimeout(timer);
        } else {
            setCanResend(true);
        }
    }, [timeLeft]);

    const handleCodeChange = (value) => {
        setCode(value);
        setError('');
        if (value.length === 6) {
            handleVerify(value)
        }
    };

    const handleVerify = async (newVal) => {
        if ((newVal || code).length !== 6) {
            setError('Please enter the complete 6-digit code');
            return;
        }

        setLoading(true);
        try {
            // Here you would typically verify the code with your backend
            // For now, we'll just simulate a successful verification
            await new Promise(resolve => setTimeout(resolve, 1000));
            props.onCheckCode && props.onCheckCode(newVal || code);
        } catch (error) {
            setError('Invalid verification code. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleResend = (e) => {
        e.preventDefault();
        if (!canResend) return;

        // Reset timer and resend state
        setTimeLeft(30);
        setCanResend(false);
        props.onRequestCode()

        // Add your resend logic here
    };

    return (
        <div className="fill-code">
            <h1>{t('login.verify_email')}</h1>
            <p className="description">{t('login.enter_code_description')}</p>

            <div className="code-input-container">
                <div className="code-input">
                <OtpInput
                    value={code} inputType="number"
                    onChange={handleCodeChange}
                    numInputs={6}
                    renderSeparator={<span className="divider">{` - `}</span>}
                    renderInput={(props) => <Input {...props} className="code-input-item"  />}
                />
                </div>

            </div>

            {error && (
                <div className="error-message">
                    <span>{error}</span>
                </div>
            )}

            <Button
                type="primary"
                block
                className="verify-btn"
                onClick={handleVerify}
                loading={loading}
            >
                {t('login.verify')}
            </Button>

            <p className="resend-text">
                {t('login.didnt_receive_code')} {
                    canResend ?
                        <a href="#" onClick={handleResend}>{t('login.resend')}</a> :
                        <span className="timer">{t('login.wait_seconds').replace('{seconds}', timeLeft)}</span>
                }
            </p>
        </div>
    );
};

export default FillCode;
